module.exports = __webpack_public_path__ + "img/9788990449078.61f45897.jpg";